export default __webpack_public_path__ + "static/solar-loan-0455dfeb98f47d008317f01e4f12010d.webp";